<template>
  <div class="pagination">
    <div class="header">
      <span>Mostrando {{ from }} a {{ to }} de {{ total }}</span>
    </div>
    <div class="pages">
      <span>Páginas:</span>
      <ul
        v-for="(page, index) in pages"
        :key="page"
      >
        <li
          v-if="page !== '...'"
          class="item"
          :class="{ current: page === current }"
          @click="changePage(page)"
        >
          {{ page }}
        </li>
        <li
          v-else
          class="item"
        >
          {{ page }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Paginacao',
  props: {
    currentPage: {
      type: [String, Number],
      default: 0,
    },
    total: {
      type: [String, Number],
      required: true,
    },
    perPage: {
      type: [String, Number],
      default: 10,
    },
    from: {
      type: Number,
      default: 1,
    },
    to: {
      type: Number,
      default: 1,
    },
    delta: {
      type: Number,
      default: 2,
      required: false,
    },
  },
  computed: {
    showPrevious() {
      return this.current > 1;
    },
    showNext() {
      return this.total > this.perPage * this.current;
    },
    current() {
      return this.currentPage;
    },
    pages() {
      const lastPage = Math.ceil(this.total / this.perPage);
      if (lastPage <= 1) return [1];
      return this.pageRange(lastPage);
    },
  },
  methods: {
    changePage(currentPage) {
      this.currentPage = currentPage;
      this.$emit('change-page', currentPage);
    },
    pageRange(lastPage) {
      let left  = this.currentPage - this.delta;
      let right = this.currentPage + this.delta + 1;
      let range   = [],
      pages   = [],
      j;

      for (let i = 1; i <= lastPage; i++) {
        if (i === 1 || i === lastPage || (i >= left && i < right)) {
          range.push(i);
        }
      }

      range.forEach(function (i) {
        if (j) {
          if (i - j === 2) {
            pages.push(j + 1);
          } else if (i - j !== 1) {
            pages.push('...');
          }
        }
        pages.push(i);
        j = i;
      });
      return pages;
    },
  },
};
</script>

<style lang="scss" scoped>
$light-grey: #cccccc;
$dark-grey: #333333;
$orange: #f90;
$dark-orange: #f63;
.pagination {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;;
  li, span {
    font-size: 14px;
    font-weight: 700;
  }
  .pages {
    display: flex;
    flex-direction: row;
    align-items: center;;
    .item {
      cursor: pointer;
      background-color: white;
      &.current {
        cursor: default;
        z-index: 2;
        text-decoration: underline;
      }
      + .item {
        margin-left: -1px;
        margin-right: 0;
      }
    }

    ul, span {
      padding: 0 6px 0 0;
      margin: 0;
    }

  }
}
</style>
